export default __webpack_public_path__ + "static/media/Boots of Vehement Thunder.f2e46deb.jpg";